import { useEffect, useState } from "react";
import { FormatIndianDate } from "../../../../../app/utility/formatIndianDate";
import { DynamicForm } from "../../../../../components/form-builder/form";
import { Modal } from "react-bootstrap";
import { CRMService } from "../../../../../app/core/crm.service";
import { useParams } from "react-router-dom";

export const TasksAndFollows = () => {
    const params = useParams();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [tasksList, setTasksList] = useState<any>([]);
    const [show, setShow] = useState<boolean>(false);
    const handleShow = () => {
        setShow(true);
    };

    useEffect(() => {
        getRemaindersData();
    }, []);

    const getRemaindersData = async () => {
        try {
            let payload = {
                ...(params.id && { cId: params.id }),
            }
            const res = await CRMService.GET_NOTES(payload);
            const resData = res?.results || [];
            console.log(resData, "resData");
            const finalArray = flattenData(resData);
            setTasksList(finalArray);
        }
        catch (err) { }
    }

    const flattenData = (data: any[]) => {
        let result: any[] = [];

        data.forEach(item => {

            // tasks → type: "tasks"
            if (item.tasks) {
                const tasks = item.tasks.map((t: any) => ({
                    ...t,
                    type: "tasks",
                    created_date: item.created_date,
                    parent_id: item._id
                }));
                result = [...result, ...tasks];
            }

            // actions → type: "actions"
            if (item.actions) {
                const actions = item.actions.map((a: any) => ({
                    ...a,
                    type: "actions",
                    created_date: item.created_date,
                    parent_id: item._id
                }));
                result = [...result, ...actions];
            }

            // reminders → type: "reminders"
            if (item.reminders) {
                const reminders = item.reminders.map((r: any) => ({
                    ...r,
                    type: "reminders",
                    created_date: item.created_date,
                    parent_id: item._id
                }));
                result = [...result, ...reminders];
            }

        });

        return result;
    };

    // const tasksData = [
    //     {
    //         description: "Follow-up Needed for Pricing & Customization Options",
    //         date: "2025-07-22T09:45:00.000Z",
    //     },
    //     {
    //         description: "call with client to discuss sales and marketing strategy",
    //         date: "2025-07-22T08:00:00.000Z",
    //     },
    //     {
    //         description: "Demo with XYZ Pvt Ltd - Product Overview",
    //         date: "2025-07-21T11:45:00.000Z",
    //     },
    //     {
    //         description: "Sent product catalog and price list",
    //         date: "2025-07-21T10:30:00.000Z",
    //     },
    //     {
    //         description: "Follow up with client about proposal",
    //         date: "2025-07-21T09:15:00.000Z",
    //     },
    //     {
    //         description: "Schedule webinar invite email",
    //         date: "2025-07-19T13:00:00.000Z",
    //     },
    //     {
    //         description:
    //             "Scheduled meeting for Internal review – July Campaign Performance",
    //         date: "2025-07-18T14:15:00.000Z",
    //     },
    //     {
    //         description: "Posted How to Use Our Platform video on LinkedIn",
    //         date: "2025-06-30T15:30:00.000Z",
    //     },
    // ];

    const [formData, setFormData] = useState<any>([
        {
            title: "formArray",
            label: "Description",
            name: "description",
            fields: [
                {
                    fields: [
                        {
                            title: "textArea",
                            type: "text",
                            label: "Description",
                            formFloating: false,
                            name: "task_description",
                            value: "",
                            required: false,
                            placeholder: "Enter description",
                            error: "Enter description",
                            column: 5,
                        },
                        {
                            type: "button",
                            class:
                                "col-md-2 d-flex justify-content-end custom_form_btn mt-4 pt-2",
                            buttons: [
                                {
                                    title: "Add",
                                    icons: "bi bi-plus-circle",
                                    action: "addDescription",
                                    class: "btn btn-primary px-4 btn-sm f16 me-1",
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            title: "formArray",
            label: "Actions",
            name: "actions",
            fields: [
                {
                    fields: [
                        {
                            title: "input",
                            type: "date",
                            label: "Select Date",
                            formFloating: false,
                            name: "date",
                            value: "",
                            required: false,
                            placeholder: "Enter date",
                            error: "Enter date",
                            column: 5,
                        },
                        {
                            title: "textArea",
                            type: "text",
                            label: "Description",
                            formFloating: false,
                            name: "description",
                            value: "",
                            required: false,
                            placeholder: "Enter description",
                            error: "Enter description",
                            column: 5,
                        },
                        {
                            type: "button",
                            class:
                                "col-md-2 d-flex justify-content-end custom_form_btn mt-4 pt-2",
                            buttons: [
                                {
                                    title: "Add",
                                    icons: "bi bi-plus-circle",
                                    action: "addActions",
                                    class: "btn btn-primary px-4 btn-sm f16 me-1",
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            title: "formArray",
            label: "Reminders",
            name: "reminders",
            fields: [
                {
                    fields: [
                        {
                            title: "input",
                            type: "time",
                            label: "Select Time",
                            formFloating: false,
                            name: "time",
                            value: "",
                            required: false,
                            placeholder: "Enter time",
                            error: "Enter time",
                            column: 3,
                        },
                        {
                            title: "input",
                            type: "date",
                            label: "Select Date",
                            formFloating: false,
                            name: "date",
                            value: "",
                            required: false,
                            placeholder: "Enter date",
                            error: "Enter date",
                            column: 3,
                        },
                        {
                            title: "textArea",
                            type: "text",
                            label: "Description",
                            formFloating: false,
                            name: "description",
                            value: "",
                            required: false,
                            placeholder: "Enter description",
                            error: "Enter description",
                            column: 4,
                        },
                        {
                            type: "button",
                            class:
                                "col-md-2 d-flex justify-content-end custom_form_btn mt-4 pt-2",
                            buttons: [
                                {
                                    title: "Add",
                                    icons: "bi bi-plus-circle",
                                    action: "addReminders",
                                    class: "btn btn-primary px-4 btn-sm f16 me-1",
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            type: "button",
            class: "col-md-12 d-flex justify-content-center my-2",
            buttons: [
                {
                    title: "Cancel",
                    action: "cancel",
                    class: "btn btn-outline-secondary px-4 btn-sm f16",
                },
                {
                    title: "Submit",
                    action: "add",
                    isCheckFormValidation: true,
                    class: "btn btn-primary px-4 btn-sm f16 ms-1",
                },
            ],
        },
    ]);

    const onSubmit = (event: any) => {
        const data = event;
        console.log(data,"hjcbkxb ");
        if (data.type === "addDescription") {
            const form = formData;
            form[event.index].fields.push({
                fields: [
                    {
                        title: "textArea",
                        type: "text",
                        label: "Description",
                        formFloating: false,
                        name: "task_description",
                        value: "",
                        required: false,
                        placeholder: "Enter description",
                        error: "Enter description",
                        column: 5,
                    },
                    {
                        type: "button",
                        class:
                            "col-md-2 d-flex justify-content-end custom_form_btn mt-4 pt-2",
                        buttons: [
                            {
                                title: "Add",
                                icons: "bi bi-plus-circle",
                                action: "addDescription",
                                class: "btn btn-primary px-4 btn-sm f16 me-1",
                            },
                        ],
                    },
                ],
            });
            form[event.index].fields?.forEach((element: any, index: number) => {
                if (form[event.index].fields.length - 1 !== index)
                    element.fields[1].buttons = [
                        {
                            title: "Delete",
                            icons: "bi bi-trash",
                            action: "deleteDescription",
                            class: "btn btn-danger px-4 btn-sm f16 me-1",
                        },
                    ];
            });
            setFormData([...form]);
        } else if (data?.type === "deleteDescription") {
            const form = formData;
            form[event.index].fields.splice(event.sunIndex, 1);
            form[event.index].fields?.forEach((element: any, index: number) => {
                if (form[event.index].fields.length - 1 !== index)
                    element.fields[1].buttons = [
                        {
                            title: "Delete",
                            icons: "bi bi-trash",
                            action: "deleteDescription",
                            class: "btn btn-danger px-4 btn-sm f16 me-1",
                        },
                    ];
            });
            setFormData([...form]);
        } else if (data.type === "addActions") {
            const form = formData;
            form[event.index].fields.push({
                fields: [
                    {
                        title: "input",
                        type: "date",
                        label: "Select Date",
                        formFloating: false,
                        name: "date",
                        value: "",
                        required: false,
                        placeholder: "Enter date",
                        error: "Enter date",
                        column: 5,
                    },
                    {
                        title: "textArea",
                        type: "text",
                        label: "Description",
                        formFloating: false,
                        name: "description",
                        value: "",
                        required: false,
                        placeholder: "Enter description",
                        error: "Enter description",
                        column: 5,
                    },
                    {
                        type: "button",
                        class:
                            "col-md-2 d-flex justify-content-end custom_form_btn mt-4 pt-2",
                        buttons: [
                            {
                                title: "Add",
                                icons: "bi bi-plus-circle",
                                action: "addActions",
                                class: "btn btn-primary px-4 btn-sm f16 me-1",
                            },
                        ],
                    },
                ],
            });
            form[event.index].fields?.forEach((element: any, index: number) => {
                if (form[event.index].fields.length - 1 !== index)
                    element.fields[2].buttons = [
                        {
                            title: "Delete",
                            icons: "bi bi-trash",
                            action: "deleteActions",
                            class: "btn btn-danger px-4 btn-sm f16 me-1",
                        },
                    ];
            });
            setFormData([...form]);
        } else if (data.type === "deleteActions") {
            const form = formData;
            form[event.index].fields.splice(event.sunIndex, 1);
            form[event.index].fields?.forEach((element: any, index: number) => {
                if (form[event.index].fields.length - 1 !== index)
                    element.fields[2].buttons = [
                        {
                            title: "Delete",
                            icons: "bi bi-trash",
                            action: "deleteActions",
                            class: "btn btn-danger px-4 btn-sm f16 me-1",
                        },
                    ];
            });
            setFormData([...form]);
        } else if (data.type === "addReminders") {
            const form = formData;
            form[event.index].fields.push({
                fields: [
                    {
                        title: "input",
                        type: "time",
                        label: "Select Time",
                        formFloating: false,
                        name: "time",
                        value: "",
                        required: false,
                        placeholder: "Enter time",
                        error: "Enter time",
                        column: 3,
                    },
                    {
                        title: "input",
                        type: "date",
                        label: "Select Date",
                        formFloating: false,
                        name: "date",
                        value: "",
                        required: false,
                        placeholder: "Enter date",
                        error: "Enter date",
                        column: 3,
                    },
                    {
                        title: "textArea",
                        type: "text",
                        label: "Description",
                        formFloating: false,
                        name: "description",
                        value: "",
                        required: false,
                        placeholder: "Enter description",
                        error: "Enter description",
                        column: 4,
                    },
                    {
                        type: "button",
                        class:
                            "col-md-2 d-flex justify-content-end custom_form_btn mt-4 pt-2",
                        buttons: [
                            {
                                title: "Add",
                                icons: "bi bi-plus-circle",
                                action: "addReminders",
                                class: "btn btn-primary px-4 btn-sm f16 me-1",
                            },
                        ],
                    },
                ],
            });
            form[event.index].fields?.forEach((element: any, index: number) => {
                if (form[event.index].fields.length - 1 !== index)
                    element.fields[3].buttons = [
                        {
                            title: "Delete",
                            icons: "bi bi-trash",
                            action: "deleteReminders",
                            class: "btn btn-danger px-4 btn-sm f16 me-1",
                        },
                    ];
            });
            setFormData([...form]);
        } else if (data.type === "deleteReminders") {
            const form = formData;
            form[event.index].fields.splice(event.sunIndex, 1);
            form[event.index].fields?.forEach((element: any, index: number) => {
                if (form[event.index].fields.length - 1 !== index)
                    element.fields[3].buttons = [
                        {
                            title: "Delete",
                            icons: "bi bi-trash",
                            action: "deleteReminders",
                            class: "btn btn-danger px-4 btn-sm f16 me-1",
                        },
                    ];
            });
            setFormData([...form]);
        } else if (data.type === "add") {
            const formData = event?.formData;
            console.log("Submitted Data:", formData);
            console.log("event", event);
            setShow(false);
        }
        else if (data.type === "cancel") {
            setShow(false);
        }
        console.log(data.type,"data.type");
    };

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mt-3">
                <h5 className="mb-0 fw-bold">Tasks & Follows</h5>
                <button
                    className="btn btn-primary rounded border-0 fs-14"
                    onClick={handleShow}
                >
                    Add Task
                </button>
            </div>

            <div>
                {tasksList.map((value: any, index: any) => (
                    <div key={index} className="card my-2 box-shadow border-0 rounded-4">
                        <div className="card-body py-2" style={{ lineHeight: "1.2" }}>
                            <div className="fs-14 mt-2 mb-0">{value.description}</div>
                            <div className="row">
                                {(value?.type === "reminders" || value?.type === "actions") && <div className="col-md-4">
                                    <h6 className="mb-0 fs-14 mt-2">Date : {FormatIndianDate(value.date, "")}</h6>
                                </div>}
                                {value?.type === "reminders" && <div className="col-md-4">
                                    <h6 className="mb-0 fs-14 mt-2">Time : {value.time}</h6>
                                </div>}
                            </div>
                            <div className="text-muted text-end fs-12">
                                {FormatIndianDate(value.created_date, "datetime")}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <Modal show={show} centered size="lg">
                <Modal.Header>
                    <Modal.Title>Add Task</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DynamicForm
                        userFormData={formData}
                        columns={1}
                        isEdit={isEdit}
                        key={JSON.stringify(formData)}
                        onFormSubmitEvent={(e) => onSubmit(e)}
                        customClass={"display-block"}
                        isNotEmptyFormAfterSubmit={true}
                        cancelRoute={undefined}
                        formControls=""
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
};
